// import { Pagination } from "@mui/material";
// import Button from "@mui/material/Button";
// import React, { useEffect, useState } from "react";
// import { NavLink, useHistory } from "react-router-dom";

// export const PaginationComponent = ({
//   initPageNumber,
//   initItemsPerPageCount,
//   startIndex,
//   endIndex,
//   setStartIndex,
//   setEndIndex,
//   initTotalEntries,
//   setParamsOnParent,
// }) => {
//   const [totalEntries, setTotalEntries] = useState(initTotalEntries);
//   const [itemsPerPageCount, setItemsPerPageCount] = useState(
//     initItemsPerPageCount
//   );
//   const [previousItemsPerCount, setPreviousItemsPerCount] = useState(
//     initItemsPerPageCount
//   );
//   const [pageNumber, setPageNumber] = useState(initPageNumber);
//   const [pageCount, setPageCount] = useState(0);

//   // useEffect(() => {
//   //   setTotalEntries(initTotalEntries);
//   //   setItemsPerPageCount(initItemsPerPageCount);
//   //   setPreviousItemsPerCount(initItemsPerPageCount);
//   //   setPageNumber(initPageNumber);
//   // }, []);

//   useEffect(() => {
//     setStartIndex(pageNumber * itemsPerPageCount - itemsPerPageCount + 1);
//     setEndIndex(pageNumber * itemsPerPageCount);
//   }, [pageNumber, itemsPerPageCount]);

//   useEffect(() => {
//     setTotalEntries(initTotalEntries);
//   }, [initTotalEntries]);

//   useEffect(() => {
//     setPageCount(Math.ceil(totalEntries / itemsPerPageCount));
//     setPageNumber((prevPageNumber) =>
//       Math.ceil((prevPageNumber * previousItemsPerCount) / itemsPerPageCount)
//     );
//     setPreviousItemsPerCount(itemsPerPageCount);
//   }, [itemsPerPageCount, totalEntries]);

//   useEffect(() => {
//     setParamsOnParent({
//       page: pageNumber,
//       itemsPerPageCount: itemsPerPageCount,
//     });
//   }, [pageNumber, itemsPerPageCount]);

//   return (
//     <div className="pagination flex !flex-row !items-center !justify-center">
//       <div>
//         <p>
//           showing {pageNumber * itemsPerPageCount - itemsPerPageCount + 1} to
//           {pageNumber * itemsPerPageCount} of {totalEntries} entries
//         </p>
//       </div>
//       <div>
//         <Pagination
//           onChange={(event, page) => {
//             setPageNumber(page);
//           }}
//           page={pageNumber}
//           count={pageCount}
//           shape="rounded"
//         ></Pagination>
//       </div>

//       <div>
//         <select
//           value={itemsPerPageCount}
//           onChange={(event) => setItemsPerPageCount(Number(event.target.value))}
//         >
//           <option value={5}>5/page</option>
//           <option value={10}>10/page</option>
//           <option value={15}>15/page</option>
//         </select>
//       </div>

//       <div>
//         <span> go to</span>
//         <input
//           onChange={(event) => {
//             setPageNumber(
//               Math.min(Math.max(Number(event.target.value), 1), pageCount)
//             );
//           }}
//           type="number"
//           style={{ width: "50px" }}
//         ></input>
//       </div>
//     </div>
//   );
// };



import { Pagination } from "@mui/material";
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";

export const PaginationComponent = ({
  initPageNumber,
  initItemsPerPageCount,
  startIndex,
  endIndex,
  setStartIndex,
  setEndIndex,
  initTotalEntries,
  setParamsOnParent,
}) => {
  const [totalEntries, setTotalEntries] = useState(initTotalEntries);
  const [itemsPerPageCount, setItemsPerPageCount] = useState(initItemsPerPageCount);
  const [previousItemsPerCount, setPreviousItemsPerCount] = useState(initItemsPerPageCount);
  const [pageNumber, setPageNumber] = useState(initPageNumber);
  const [pageCount, setPageCount] = useState(0);

  useEffect(() => {
    setStartIndex(pageNumber * itemsPerPageCount - itemsPerPageCount + 1);
    setEndIndex(pageNumber * itemsPerPageCount);
  }, [pageNumber, itemsPerPageCount]);

  useEffect(() => {
    setTotalEntries(initTotalEntries);
  }, [initTotalEntries]);

  useEffect(() => {
    setPageCount(Math.ceil(totalEntries / itemsPerPageCount));
    setPageNumber((prevPageNumber) =>
      Math.ceil((prevPageNumber * previousItemsPerCount) / itemsPerPageCount)
    );
    setPreviousItemsPerCount(itemsPerPageCount);
  }, [itemsPerPageCount, totalEntries]);

  useEffect(() => {
    setParamsOnParent({
      page: pageNumber,
      itemsPerPageCount: itemsPerPageCount,
    });
  }, [pageNumber, itemsPerPageCount]);

  return (
    <div className="w-full px-4 py-3 flex flex-col sm:flex-row sm:flex-wrap sm:justify-between items-center gap-4 bg-white">

      {/* Showing Text */}
      <div className="text-sm text-center sm:text-left">
        <p>
          Showing{" "}
          <span className="font-medium">
            {pageNumber * itemsPerPageCount - itemsPerPageCount + 1}
          </span>{" "}
          to{" "}
          <span className="font-medium">
            {Math.min(pageNumber * itemsPerPageCount, totalEntries)}
          </span>{" "}
          of <span className="font-medium">{totalEntries}</span> entries
        </p>
      </div>

      {/* Pagination */}
      <div className="flex justify-center">
        <Pagination
          onChange={(event, page) => {
            setPageNumber(page);
          }}
          page={pageNumber}
          count={pageCount}
          shape="rounded"
          size="small"
        />
      </div>

      {/* Select Entries per Page */}
      <div className="flex items-center gap-2">
        <label htmlFor="itemsPerPage" className="text-sm whitespace-nowrap">
          Items per page:
        </label>
        <select
          id="itemsPerPage"
          value={itemsPerPageCount}
          onChange={(event) => setItemsPerPageCount(Number(event.target.value))}
          className="border px-2 py-1 rounded text-sm"
        >
          <option value={5}>5/page</option>
          <option value={10}>10/page</option>
          <option value={15}>15/page</option>
        </select>
      </div>

      {/* Go to Page */}
      <div className="flex items-center gap-2">
        <label htmlFor="gotoPage" className="text-sm whitespace-nowrap">
          Go to:
        </label>
        <input
          id="gotoPage"
          type="number"
          min={1}
          max={pageCount}
          value={pageNumber}
          onChange={(event) => {
            const value = Number(event.target.value);
            setPageNumber(Math.min(Math.max(value, 1), pageCount));
          }}
          className="w-16 border px-2 py-1 rounded text-sm"
        />
      </div>
    </div>
  );
};
